module.exports = __webpack_public_path__ + "img/in-pc.941bfe8c.png";